import React, { useContext, useMemo } from 'react'
import { Checkbox, Tooltip } from 'antd'
import PropTypes from 'prop-types'

import { AuthContext } from '../../../../account/contexts'
import { useCanUserAssignTask, useCanUserUnassignTask } from '../../../hooks'

const onChange = (isChecked, task, loggedInUser, assignTask, unassignTask) =>
  isChecked
    ? assignTask({ variables: { id: task.id, toUserId: loggedInUser.id } })
    : unassignTask({ variables: { id: task.id } })

const TaskTableAssignedColumn = ({
  task,
  taskType,
  permissions,
  assignTask,
  unassignTask,
}) => {
  const { user: loggedInUser } = useContext(AuthContext)
  const { assignedTo, isAssignable = true } = task

  const canUserAssignTask = useCanUserAssignTask(task, taskType, permissions)
  const canUserUnassignTask = useCanUserUnassignTask(permissions.UNASSIGN)

  const isMenuAttachedToCluster = useMemo(
    () => task.menu?.menuScrapingClusterId,
    [task.menu],
  )

  const isDisabled = assignedTo
    ? !canUserUnassignTask
    : !canUserAssignTask || !!isMenuAttachedToCluster || !isAssignable

  const checkbox = (
    <Checkbox
      checked={!!assignedTo}
      disabled={isDisabled}
      onChange={event =>
        onChange(
          event.target.checked,
          task,
          loggedInUser,
          assignTask,
          unassignTask,
        )
      }
      onClick={event => event.stopPropagation()}
    >
      {assignedTo ? assignedTo.name : 'Assign to me'}
    </Checkbox>
  )

  return !isAssignable ? (
    <Tooltip
      title="Task is not ready for assignment in the workflow"
      trigger="hover"
    >
      {checkbox}
    </Tooltip>
  ) : (
    checkbox
  )
}

TaskTableAssignedColumn.propTypes = {
  task: PropTypes.object.isRequired,
  taskType: PropTypes.string.isRequired,
  permissions: PropTypes.object.isRequired,
  assignTask: PropTypes.func.isRequired,
  unassignTask: PropTypes.func.isRequired,
}

export default TaskTableAssignedColumn
